import { render, staticRenderFns } from "./WillBeneficiariesIllnessWorkingDetails.vue?vue&type=template&id=2d989247"
import script from "./WillBeneficiariesIllnessWorkingDetails.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesIllnessWorkingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports